import { Link } from "react-router-dom";
import { ArrowRight, ArrowDown } from "lucide-react";
import { HERO_IMAGE } from "../data/content";

const Hero = () => {
    return (
        <section
            data-testid="hero-section"
            className="relative h-[100svh] min-h-[640px] w-full overflow-hidden bg-samora-ink"
        >
            {/* Background image */}
            <div className="absolute inset-0">
                <img
                    src={HERO_IMAGE}
                    alt="A cinematic, warm-lit modern Indian living room by Samora Spaces"
                    className="w-full h-full object-cover"
                    loading="eager"
                    fetchPriority="high"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/70" />
            </div>

            {/* Top eyebrow bar */}
            <div className="absolute top-24 md:top-32 left-0 right-0 z-10">
                <div className="max-w-[1440px] mx-auto px-6 md:px-12 flex justify-between items-center text-white/80">
                    <p
                        className="eyebrow text-samora-gold"
                        data-testid="hero-eyebrow"
                    >
                        Samora Spaces · Lux Design Studio · Bengaluru
                    </p>
                    <p className="hidden md:block eyebrow text-white/60">
                        Est. 2019 · By appointment
                    </p>
                </div>
            </div>

            {/* Headline */}
            <div className="relative z-10 h-full flex items-end pb-24 md:pb-32">
                <div className="max-w-[1440px] w-full mx-auto px-6 md:px-12">
                    <div className="max-w-5xl">
                        <h1
                            data-testid="hero-headline"
                            className="font-display text-white leading-[0.95] tracking-tight animate-fade-up"
                            style={{
                                fontSize: "clamp(2.5rem, 8vw, 7.5rem)",
                                fontWeight: 400,
                            }}
                        >
                            Designing homes<br />
                            <span className="italic font-serif text-samora-sand">
                                that feel like you.
                            </span>
                        </h1>
                        <p
                            data-testid="hero-subheadline"
                            className="mt-8 max-w-xl text-white/85 text-base md:text-lg font-light leading-relaxed"
                        >
                            Luxury interiors crafted with thoughtful design,
                            precision execution and timeless elegance — for a
                            handful of families each year.
                        </p>
                        <div className="mt-10 md:mt-14 flex flex-col sm:flex-row gap-4">
                            <Link
                                to="/contact"
                                data-testid="hero-cta-book"
                                className="btn-samora"
                            >
                                Book Free Consultation
                                <ArrowRight size={16} strokeWidth={1.5} />
                            </Link>
                            <Link
                                to="/portfolio"
                                data-testid="hero-cta-portfolio"
                                className="btn-outline border-white text-white hover:bg-white hover:text-samora-ink"
                            >
                                View Portfolio
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            {/* Scroll indicator */}
            <div className="hidden md:flex absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex-col items-center gap-3 text-white/70">
                <span className="eyebrow text-white/60">Scroll</span>
                <ArrowDown size={16} className="animate-bounce" />
            </div>
        </section>
    );
};

export default Hero;
